import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TemplateEntityVariableEnum } from '@zaoblako/shared/common/enums/template.entity.variable.enum';
import { EditorComponent } from '@zaoblako/web/shared/dumbs/editor/editor.component';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { ListboxModule } from 'primeng/listbox';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
  standalone: true,
  selector: 'crm-template-subject-editor',
  templateUrl: './template-subject-editor.component.html',
  imports: [CommonModule, EditorComponent, ButtonComponent, ListboxModule, OverlayPanelModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateSubjectEditorComponent {
  @ViewChild('editor') public editor: EditorComponent;

  @Input() public value: string;
  @Output() public valueChange = new EventEmitter<string>();

  @Input() public height = '150px';

  public templateOptions = Object.values(TemplateEntityVariableEnum).map((option) => '{{' + option + '}}');

  public onTemplateOptionSelect(option: string) {
    this.value = this.value ? this.value + option : option;
    this.valueChange.emit(this.value);
    this.editor?.editor?.getQuill()?.focus();
  }
}
